import { useState } from 'react'
import { apiClient } from '@/services/api'
import { useErrorHandler } from '@/hooks/useAuth'

interface UseRegenerateTrolleyQRCodeReturn {
  regenerateTrolleyQRCode: (trolleyId: number) => Promise<void>
  isRegenerating: boolean
  regeneratingId: Nullable<number>
  error: Nullable<string>
}

export function useRegenerateTrolleyQRCode(): UseRegenerateTrolleyQRCodeReturn {
  const [isRegenerating, setIsRegenerating] = useState(false)
  const [regeneratingId, setRegeneratingId] = useState<Nullable<number>>(null)
  const [error, setError] = useState<Nullable<string>>(null)
  const { handleError } = useErrorHandler()

  const regenerateTrolleyQRCode = async (trolleyId: number) => {
    setIsRegenerating(true)
    setRegeneratingId(trolleyId)
    setError(null)

    try {
      await apiClient.post(`/qr-codes/${trolleyId}`)
    } catch (err) {
      const errorMessage = handleError(err)
      setError(errorMessage)
      throw err
    } finally {
      setIsRegenerating(false)
      setRegeneratingId(null)
    }
  }

  return {
    regenerateTrolleyQRCode,
    isRegenerating,
    regeneratingId,
    error,
  }
}
